/**
 * 会员状态模块
 * 管理公开会员列表、会员详情等
 */

import memberApi from '@/api/member'

const state = {
  publicMembers: [],        // 公开的注册会员列表
  memberDetail: null        // 会员详情
}

const mutations = {
  /**
   * 设置公开会员列表
   * @param state
   * @param list
   */
  setPublicMembers(state, list) {
    state.publicMembers = list
  },
  
  /**
   * 设置会员详情
   * @param state
   * @param detail
   */
  setMemberDetail(state, detail) {
    state.memberDetail = detail
  }
}

const actions = {
  /**
   * 获取公开会员列表
   * @param commit
   * @param params
   */
  async fetchPublicMembers({ commit }, params) {
    const res = await memberApi.getPublicMembers(params)
    if (res && res.code === 2000) {
      commit('setPublicMembers', res.data.list || [])
    }
    return res
  },
  
  /**
   * 获取会员详情
   * @param commit
   * @param id
   */
  async fetchMemberDetail({ commit }, id) {
    const res = await memberApi.getMemberDetail(id)
    if (res && res.code === 2000) {
      commit('setMemberDetail', res.data)
    }
    return res
  }
}

const getters = {
  publicMembers: state => state.publicMembers,
  memberDetail: state => state.memberDetail
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
